// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc56b817","455":"303b4e28","644":"306e412b"}[chunkId] + ".chunk.js";
};